import React from "react";

import {
  InputAdornment,
  TextField,
  Toolbar,
  makeStyles,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";

import { fireOnce } from "@ds-developer/frontend";
import { useTealium } from "@hubcapp/context";

import { LearnersTableToolbarProps } from "./types";
import LearnersTableTabs from "./LearnersTableTabs";

const useStyles = makeStyles(theme => ({
  root: {
    display: "block",
    padding: theme.spacing(1, 2),
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: "464px",
  },
}));

const LearnersTableToolbar: React.FC<LearnersTableToolbarProps> = ({
  searchText = "",
  onSearchChanged = () => {},
  toggleActiveFilter = () => {},
  activeFilter = true,
}) => {
  const classes = useStyles();
  const { trackEvent } = useTealium();

  return (
    <Toolbar classes={{ root: classes.root }} disableGutters>
      <LearnersTableTabs
        value={activeFilter ? 0 : 1}
        onValueChange={toggleActiveFilter}
      />
      <div className={classes.container}>
        <TextField
          variant="outlined"
          value={searchText}
          onChange={event => onSearchChanged(event.target.value)}
          placeholder="Search for learners"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          fullWidth
          data-test="learners-table-search-bar"
          onClick={() => {
            fireOnce("Calendar|Interaction|Search For Learner", () => {
              trackEvent({
                eventCategory: "Learners",
                eventAction: "Interaction",
                eventLabel: "Search For Learner",
              });
            });
          }}
        />
      </div>
    </Toolbar>
  );
};

export default LearnersTableToolbar;
